import React from 'react'
import EDInputText from '../../../../../Component/EnhancedData/EDInputText'

interface DiscountRowProps {
  value: string | number
  onInputChange: (name: string, value: any) => void
  fieldDefinition: any
  emptyColSpan?: number
  onInputError?: (fieldName: string, errorMessage: string | null) => void
}

export default function DiscountRow (props: DiscountRowProps): React.JSX.Element {
  const { value, onInputChange, onInputError, fieldDefinition, emptyColSpan = 4 } = props
  const maxColSpan = 7
  const reservedColSpan = maxColSpan - emptyColSpan

  return (
    <tr className="subtotal-row">
      <td colSpan={emptyColSpan}></td>
      <td colSpan={reservedColSpan} className="subtotal-input-cell">
        <EDInputText
          value={value}
          onInputChange={onInputChange}
          onInputError={onInputError}
          fieldDefinition={fieldDefinition}
          prefixInput={'$'}
          separator={'-'}
          className={'subtotal-input label-left'}
        />
      </td>
    </tr>
  )
}
